import Grid from "@material-ui/core/Grid";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { type ReactNode, useState } from "react";
import Statistics from "./statistics";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			"& .MuiGrid-root": {
				padding: 0,
			},
			"& .MuiBox-root": {
				padding: 0,
			},
		},
	}),
);

interface TabPanelProps {
	children?: ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index } = props;

	return (
		<>
			{value === index && (
				<Grid item md={12} xs={12} style={{ height: "100%", width: "100%" }}>
					{children}
				</Grid>
			)}
		</>
	);
}

type Props = {
	isStatisticsLoading: boolean;
};

export default function StatisticsTabs({ isStatisticsLoading }: Props) {
	const classes = useStyles();
	//Tabs and Toggle Buttons
	const [value, setValue] = useState<number>(0);

	return (
		<>
			<Grid container className={classes.root} style={{ height: "100%" }}>
				<TabPanel value={value} index={0}>
					<Statistics isStatisticsLoading={isStatisticsLoading} />
				</TabPanel>
			</Grid>
		</>
	);
}
